export default "__VITE_ASSET__D0m$OVAQ__"